import { z } from 'zod';
import { BrowserRuntimeSchema, IdSchema, SupportSessionStatusSchema, TabInfoSchema, } from './common.js';
// App channel: operator dashboard <-> server over /ws/app (session cookie).
export const AppToServerSchema = z.discriminatedUnion('t', [
    z.object({ t: z.literal('ping'), ts: z.number() }),
]);
export const ServerToAppSchema = z.discriminatedUnion('t', [
    z.object({ t: z.literal('node.state'), nodeId: IdSchema, online: z.boolean(), at: z.number() }),
    z.object({
        t: z.literal('profile.state'),
        profileId: IdSchema,
        runtime: BrowserRuntimeSchema,
        participantCount: z.number().int(),
        controllerName: z.string().optional(),
    }),
    z.object({
        t: z.literal('support-session.state'),
        profileId: IdSchema,
        supportSessionId: IdSchema,
        status: SupportSessionStatusSchema,
    }),
    z.object({ t: z.literal('tabs.changed'), profileId: IdSchema, tabs: z.array(TabInfoSchema) }),
    z.object({
        t: z.literal('notification'),
        kind: z.enum([
            'customer_done',
            'customer_joined',
            'control_requested',
            'node_offline',
            'profile_error',
        ]),
        profileId: IdSchema.optional(),
        supportSessionId: IdSchema.optional(),
        nodeId: IdSchema.optional(),
        title: z.string(),
        message: z.string(),
        at: z.number(),
    }),
    z.object({ t: z.literal('pong'), ts: z.number() }),
]);
//# sourceMappingURL=app.js.map